module.exports = __webpack_public_path__ + "static/media/logo.4de05a5b.svg";